import { useEffect, useState } from 'react'

const NARROW_SCREEN_QUERY = '(max-width: 900px)'

export const useIsNarrowScreen = (): boolean => {
  const [isNarrow, setIsNarrow] = useState(
    () => window.matchMedia(NARROW_SCREEN_QUERY).matches
  )

  useEffect(() => {
    const mediaQuery = window.matchMedia(NARROW_SCREEN_QUERY)
    const handleChange = (event: MediaQueryListEvent): void =>
      setIsNarrow(event.matches)
    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])

  return isNarrow
}
